import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetCategories } from "../../api/requests/Api";
import { Category as CategoryType } from "../../entity/Entity";
import "./Category.css";

const Category = () => {
    const [categories, setCategories] = useState<CategoryType[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            setLoading(true);
            const data = await GetCategories();
            setCategories(data);
        } catch {
            setError("Failed to load categories");
        } finally {
            setLoading(false);
        }
    };

    const handleClick = (categoryId: string) => {
        navigate(`/items?category=${categoryId}`);
    };

    if (loading) return <div className="category-loading">Загрузка...</div>;
    if (error) return <div className="category-error">{error}</div>;

    return (
        <div className="category-container-wrapper">
            <div className="category-container">
                {categories.map((cat) => (
                    <div
                        key={cat._id}
                        className="category-card"
                        onClick={() => handleClick(cat._id)}
                    >
                        <img
                            src={cat.image_link}
                            alt={cat.name}
                            className="category-image"
                        />
                        <div className="category-title">{cat.name}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Category;
